import type { ContractShapeOf, RequestHandlers } from 'shared/channels';
import type { checklistSectionContract } from 'shared/domain/checklistSection/checklistSectionContract';
import { checklistSectionSaver } from './addChecklistSection';
import { checklistSectionDeleter } from './deleteChecklistSection';
import { checklistSectionDocumentDeleter } from './deleteChecklistSectionDocument';
import { checklistSectionEditor } from './editChecklistSection';
import { checklistSectionReorderer } from './reorderChecklistSection';

/** Checklist section changes put on the HTTP queue, as the channel server runs them. */
export const queueChecklistSectionChanges = {
  create: ({ section, uniqueId }) => checklistSectionSaver.execute(section, uniqueId),
  edit: ({ section, uniqueId }) => checklistSectionEditor.execute(section, uniqueId),
  remove: ({ section, uniqueId }) => checklistSectionDeleter.execute(section, uniqueId),
  reorder: ({ section, uniqueId }) => checklistSectionReorderer.execute(section, uniqueId),
  removeDocument: ({ model, uniqueId }) => checklistSectionDocumentDeleter.execute(model, uniqueId),
} satisfies RequestHandlers<ContractShapeOf<typeof checklistSectionContract>>;
